module.exports = __webpack_public_path__ + "img/sms.a8520668.svg";